import { useState } from "react";
import { useFuturePortfolioCreateMutation } from "web_myplann/Api/Goals/useFuturePortfolioCreateMutation";
import { useFuturePortfolioDeleteMutation } from "web_myplann/Api/Goals/useFuturePortfolioDeleteMutation";
import { useFuturePortfolioUpdateMutation } from "web_myplann/Api/Goals/useFuturePortfolioUpdateMutation";
import type { PinFutureContractFormValues } from "web_myplann/Goals/Hooks/usePinFutureContractForm";
import {
	mapFutureContractFormToCreateRequest,
	mapFutureContractFormToUpdateRequest,
} from "web_myplann/Goals/Mappers/mapFutureContractForm";

type UseFutureContractActionsProps = {
	goalId: number;
};

export const useFutureContractActions = ({
	goalId,
}: UseFutureContractActionsProps) => {
	const { mutate: createFuture, isPending: isCreating } =
		useFuturePortfolioCreateMutation();
	const { mutate: updateFuture, isPending: isUpdating } =
		useFuturePortfolioUpdateMutation();
	const { mutate: removeFuture } = useFuturePortfolioDeleteMutation();

	const [deletingId, setDeletingId] = useState<number | null>(null);

	const submit = (
		values: PinFutureContractFormValues,
		editingId: number | null,
		options?: { onSuccess?: () => void },
	) => {
		if (editingId === null) {
			createFuture(mapFutureContractFormToCreateRequest(values, goalId), {
				onSuccess: options?.onSuccess,
			});
			return;
		}

		updateFuture(
			{
				id: editingId,
				goalId,
				body: mapFutureContractFormToUpdateRequest(values),
			},
			{ onSuccess: options?.onSuccess },
		);
	};

	const deleteFuture = (id: number) => {
		setDeletingId(id);
		removeFuture({ id, goalId }, { onSettled: () => setDeletingId(null) });
	};

	return {
		submit,
		deleteFuture,
		deletingId,
		isPending: isCreating || isUpdating,
	};
};
